import { render, staticRenderFns } from "./overview-projects.vue?vue&type=template&id=1841a7fe"
import script from "./overview-projects.vue?vue&type=script&lang=ts"
export * from "./overview-projects.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports